import {logstashAPI} from "../common/api/logstashAPI";
import {API_LOGSTASH_SPA} from "../common/api/apiConstants";

export const useLogger = () => {

    const logger = async (message, level = "debug", module = "unknown", stacktrace = "No stacktrace provided", xRequestID = "", duration = "") => {
        // Message is mandatory in order to avoid cases of cancelled requests and more
        if (message) {
            let body = {
                message: message,
                level: level,
                logger: module,
                timestamp: new Date().toISOString(),
                stacktrace: stacktrace,
                "X-Request-ID": xRequestID,
                duration: duration + " ms"
            };

            return logstashAPI.post(API_LOGSTASH_SPA, body)
                .catch(err => {
                    console.error(err);
                });
        } else {
            return new Promise(resolve => resolve());
        }
    };

    return {
        logger
    };
};
